import { render, staticRenderFns } from "./MatterList.vue?vue&type=template&id=3ad60208&"
import script from "./MatterList.vue?vue&type=script&lang=ts&"
export * from "./MatterList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports